import React from 'react';
import styled from 'styled-components';
import { Color, Thumbnail } from '@brokerbay/elements-web';

export interface ListingImageProps {
  size: 'medium' | 'small' | 'large';
  thumbnail?: string;
}

const ListingImage: React.FC<ListingImageProps> = ({ size, thumbnail }) => (
    <StyledImageContainer>
      <Thumbnail
        dataCy="listingPicture"
        square
        size={size ?? 'large'}
        src={thumbnail}
      />
    </StyledImageContainer>
  );

export default React.memo(ListingImage);

const StyledImageContainer = styled.div`
  display: flex;
  & .ant-image-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${Color.LIGHTER_GREY};
    border-radius: 8px;
  }
`;
